/**
 * support ssr
 * @returns boolean
 */ export function isBrowser() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
}
